export default {
  'environment': 'dev',
  'basePath': window.location.protocol + '//api.beta-forms.cliqforms.com/api',
  'recaptchaSiteKey': '6LfYh1YsAAAAAG3kt4pwe53RHyzY_TmDRVTUoPAo',
  'formsUrl': window.location.protocol + '//forms.beta-forms.cliqforms.com',
  'proofsUrl': window.location.protocol + '//proofs.beta-forms.cliqforms.com',
  'scriptsUrl': window.location.protocol + '//scripts.beta-forms.cliqforms.com',
  'qrUrl': window.location.protocol + '//qr.beta-forms.cliqforms.com',
  'sampleCsvUrl': window.location.protocol + '//' + window.location.host + '/static/sample/SampleTemplate.csv',
   paddle: {
    vendorId: 10209,
    billing: {
      enabled: true,
      environment: 'sandbox',
      clientToken: 'test_49dc4782277e65ab423ef3b4cfd',
      prices: {
        bronzeMonthly: 'pri_01kmmfyyqfwfh6ctbnfg9mkwk6',
        bronzeYearly: 'pri_01kmmg2mv1w6gqkkfw40z6vv8k',
        silverMonthly: 'pri_01kmjbv51h6xy44c7r1rn451r7',
        silverYearly: 'pri_01kmmg5sp8cgq6k12ddv0gfn98',
        goldMonthly: 'pri_01kjsjsmh1ebmphpvz3s4m5rh0',
        goldYearly: 'pri_01kjsjtvpm15sk2z9vb0a7jy7q'
      }
    },
    trialPlanId: 43188,
    trialScaleId: 43190,
    trialEnterpriseId: '',
    trialAnnualProId: 43194,
    trialAnnualScaleId: 43198,
    trialAnnualEnterpriseId: '',
    planId: 43187,
    scaleId: 43189,
    enterpriseId: 46290,
    annualProId: 43191,
    annualScaleId: 43196,
    annualEnterpriseId: '',
    singlePlanId: 68812,
    starterPlanId: 70098
  },
  'registration': {
    'recaptchaEnabled': true
  }
}